import { DeltaText } from '@spotify/plugin-confidence-activity-react';
import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

export const METRIC_STRING_CHANGE_EXTENSION =
  createMetricUpdatesChangeExtension({
    id: 'metric-string-change',
    priority: -1,
    predicate: ({ change }) => change.fieldType === 'string',
    render: ({ change }) => (
      <DeltaText
        oldText={change.oldValue ?? ''}
        newText={change.newValue ?? ''}
        disableDiff
      />
    ),
  });
